import type { StateCreator } from "zustand";

export enum JobExtractionStatus {
  GENERANDO_BUSQUEDA = "GENERANDO_BUSQUEDA",
  CALIFICANDO_VACANTES = "CALIFICANDO_VACANTES",
  AJUSTANDO_AL_PERFIL = "AJUSTANDO_AL_PERFIL",
  EXITO = "EXITO",
  ERROR = "ERROR",
  NO_RESULTADOS = "NO_RESULTADOS",
}

const PROCESSING_STATUSES: ReadonlySet<JobExtractionStatus> = new Set([
  JobExtractionStatus.GENERANDO_BUSQUEDA,
  JobExtractionStatus.CALIFICANDO_VACANTES,
  JobExtractionStatus.AJUSTANDO_AL_PERFIL,
]);

export function isProcessingStatus(status: JobExtractionStatus | null): boolean {
  return status !== null && PROCESSING_STATUSES.has(status);
}

export interface JobExtractionSliceState {
  jobExtractionStatus: JobExtractionStatus | null;
}

interface JobExtractionSliceActions {
  setJobExtractionStatus: (status: JobExtractionStatus | null) => void;
  resetJobExtractionStatus: () => void;
}

export type JobExtractionSlice = JobExtractionSliceState & JobExtractionSliceActions;

export const createJobExtractionSlice: StateCreator<
  JobExtractionSlice,
  [],
  [],
  JobExtractionSlice
> = (set) => ({
  jobExtractionStatus: null,
  setJobExtractionStatus: (status) => set({ jobExtractionStatus: status }),
  resetJobExtractionStatus: () => set({ jobExtractionStatus: null }),
});
